<template>
  <v-container id="pallet_container" pa-0 ma-0 class="pallet-container">
    <v-layout column wrap>
      <v-divider/>
      <!-- Toolbar -->
      <v-flex shrink>
        <v-toolbar class="toolbar">
          <v-toolbar-items v-show="mode === 'full'">

              <v-btn v-if="!isPatternGenAvailable" flat :disabled="multiPickOk || reorderManuallyMode || isAnySequence()" @click.native="autofill" id="btn-autofill">
                {{ $t("patternStep.autoFill") }}
                <v-icon class="i-right">apps</v-icon>
              </v-btn>
              <div v-if="isPatternGenAvailable && this.id === 0" class="d-flex pl-3">
                <div class="flex align-center items-center align-content-center pr-3 text-uppercase">
                  {{ $t('patternStep.GeneratePattern') }}
                </div>
                <v-select class="custom-height-select"
                        v-model="selectedStrategy"
                        :items=availableStrategies
                        style="width: 290px"
                        solo
                        flat
                        item-text="title"
                        item-value="id"
                        @change="updateGeneratedBoxPositions"
                        :placeholder="$t('patternStep.selectPatternStrategy')"
                        id="select-strategy"
              ></v-select>
              </div>
              <div v-if="isPatternGenAvailable && this.id === 1" class="d-flex pl-3">
                <div class="flex align-center items-center align-content-center pr-3 text-uppercase">
                  {{ $t('patternStep.PatternSymmetry') }}
                </div>
                <v-select class="custom-height-select"
                        v-model="selectedSymmetry"
                        :items=availableSymmetries
                        :disabled="this.selectedStrategy == null"
                        style="min-width: 290px"
                        solo
                        flat
                        item-text="title"
                        item-value="id"
                        @change="updateGeneratedBoxPositions"
                        :placeholder="$t('patternStep.selectPatternSymmetry')"
                        id="select-symmetry"
              ></v-select>
              </div>
              <div class="d-flex pl-3">
                <div class="flex align-center items-center align-content-center pr-3 text-uppercase">
                  {{ $t('patternStep.Actions') }}
                </div>
                <v-select id="select-actions" class="custom-height-select"
                          :placeholder="$t('patternStep.selectAction')"
                          :items="filteredActions"
                          item-value="value"
                          item-disabled="disabled"
                          style="min-width: 250px"
                          solo
                          flat
                          @input="handleAction"
                >
                  <template #item="{ item }">
                    <div class="d-flex align-center items-center justify-center"
                         :id="'btn-' + item.value"
                    >
                      <div>{{ $t(item.text) }}</div>
                      <v-icon class="i-right">{{ item.icon }}</v-icon>
                    </div>
                  </template>
                  <template #selection="{ item }">
                    <div class="d-flex align-center items-center justify-center">
                      <div>{{ $t('patternStep.selectAction') }}</div>
                    </div>
                  </template>
                </v-select>
              </div>
            </v-toolbar-items>
            <v-toolbar-items>
              <v-btn flat :disabled="multiPickOk || reorderManuallyMode"
                     @click.native="rotateBox" v-show="mode !== 'full'" id="btn-rotate-right">
                {{ $t("patternStep.rotate") }}
                <v-icon class="i-right">rotate_right</v-icon>
              </v-btn>

              <v-btn flat :disabled="autoOrder || reorderManuallyMode" @click.native="reorderManually(true)"
                     id="btn-reorder">
                {{ $t("patternStep.orderMan") }}
                <v-icon class="i-right">touch_app</v-icon>
              </v-btn>

              <v-btn flat v-if="!groupSelection && !groupWithPusher"
                     :disabled="!multiPickOk || reorderManuallyMode || groupSelection || allSelected()"
                     @click.native="group" id="btn-group">
                {{ $t("patternStep.group") }}
                <v-icon class="i-right">group_work</v-icon>
              </v-btn>
              <!-- group with pusher -->
              <v-btn flat v-if="!groupSelection && groupWithPusher"
                     :disabled="!multiPickOk || reorderManuallyMode || groupSelection || allSelected()"
                     @click.native="group" id="btn-group-pusher">
                {{ $t("patternStep.groupWithPusher") }}
                <v-icon class="i-right">compress</v-icon>
              </v-btn>

              <v-btn flat v-if="groupSelection"
                     :disabled="!groupSelection || allSelected()"
                     @click.native="ungroup" id="btn-ungroup">
                {{ $t("patternStep.ungroup") }}
                <v-icon class="i-right">group_work</v-icon>
              </v-btn>
              <!-- show options to choose rightPalletMode -->
              <div v-if="showMirrorLayerOptions() && side ==='R'" class="d-flex pl-3">
                <div class="flex align-center items-center align-content-center pr-3 text-uppercase">
                  {{ $t('patternStep.LayerOptions') }}
                </div>
                <div class="flex align-content-center items-center justify-center">
                  <v-select class="custom-height-select"
                            v-model="rightPalletMode"
                            :items=rightPalletSelectionItems
                            :disabled="!autoOrder || boxPositions.length === 0 || multiSelect"
                            style="width: 400px"
                            solo
                            flat
                  >

                    <template #item="{ item }">
                      <div class="d-flex align-center items-center justify-center">
                        <div>{{ item.text }}</div>
                        <v-icon class="i-right" :style="item.iconStyle">{{ item.icon }}</v-icon>
                      </div>
                    </template>
                    <template #selection="{ item }">
                      <div class="d-flex align-center items-center justify-center">
                        <div>{{ item.text }}</div>
                        <v-icon class="i-right" :style="item.iconStyle">{{ item.icon }}</v-icon>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </v-toolbar-items>
          </v-toolbar>
      </v-flex>

      <!-- WORKSPACE -->
      <v-flex grow class="workspace workspace-height">
        <!-- Canvas -->
        <div :id="'paledit'+side" :ref="'paledit'+side" class="paledit">
          <canvas :id="'pallet_canvas'+side" :ref="'pallet_canvas'+side"/>
        </div>

        <!-- Side Toolbar -->
        <div :class="isCustomSolution() ? 'asideToolsCustom' : 'asideTools'">
          <v-layout column fill-height wrap>
            <div>
              <v-flex v-show="mode === 'full'">
                <v-checkbox v-model="isSnap" class="checkbox" :label="$t('patternStep.snap')"
                            :disabled="reorderManuallyMode" @change="setSnap" id="cb-snap"/>
              </v-flex>

              <v-flex v-show="!isCustomSolution()">
                <v-checkbox v-model="autoOrder" class="checkbox" :label="$t('patternStep.autoOrder')"
                            @change="setAutoOrder" id="cb-auto-order"/>
              </v-flex>

              <v-flex v-show="!isCustomSolution() && (mode === 'full' || mode.includes('group'))" xs12>
                <v-checkbox v-model="multiSelect" class="checkbox" :label="$t('patternStep.multiSel')"
                            :disabled="!(mode === 'full' || mode.includes('group')) || reorderManuallyMode || allSelected()"
                            @change="setMultiSelect"
                            :color="multiSelect ? '#EE0000' : ''"
                            id="cb-multi-select"
                />
              </v-flex>

              <v-flex v-show="showIgnoreGripper() && (mode === 'full' || mode.includes('group'))" xs12>
                <v-checkbox v-model="ignoreGripperOutside" class="checkbox"
                            :label="$t('patternStep.ignoreGripperOutside')"
                            :disabled="!(mode === 'full' || mode.includes('group')) || reorderManuallyMode"
                            @change="setIgnoreGripperOutside" id="cb-ignore-gripper"/>
              </v-flex>
              <v-flex v-show="showIgnoreBoxRotation() && (mode === 'full' || mode.includes('group'))" xs12>
                <v-checkbox v-model="ignoreRotationLimit" class="checkbox" :label="$t('patternStep.ignoreRotation')"
                            :disabled="!(mode === 'full' || mode.includes('group')) || reorderManuallyMode"
                            @change="setIgnoreBoxRotation" id="cb-ignore-rotation"/>
              </v-flex>
            </div>
            <v-flex grow v-if="showConveyorPreview()" class="conveyor-preview-wrap">
              <div id="pattern-conveyor-preview" class="conveyor-preview" aria-label="Conveyor preview">
                <svg class="conveyor-preview-svg" :viewBox="conveyorPreviewViewBox" preserveAspectRatio="xMidYMid meet">
                  <defs>
                    <marker :id="conveyorPreviewSvgIds.xArrow" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto" markerUnits="strokeWidth">
                      <path d="M0,0 L8,4 L0,8 z" fill="#C62828"/>
                    </marker>
                    <marker :id="conveyorPreviewSvgIds.yArrow" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto" markerUnits="strokeWidth">
                      <path d="M0,0 L8,4 L0,8 z" fill="#2E7D32"/>
                    </marker>
                    <marker :id="conveyorPreviewSvgIds.flowArrow" markerWidth="10" markerHeight="10" refX="8" refY="5" orient="auto" markerUnits="strokeWidth">
                      <path d="M0,0 L10,5 L0,10 z" fill="#5f6a6a"/>
                    </marker>
                  </defs>
                  <g class="conveyor-preview-frame">
                    <rect class="conveyor-preview-belt"
                          :x="conveyorPreviewLane.deckX"
                          :y="conveyorPreviewLane.y"
                          :width="conveyorPreviewLane.deckWidth"
                          :height="conveyorPreviewLane.height"
                          rx="8"
                          ry="8"/>
                    <rect class="conveyor-preview-rail"
                          :x="conveyorPreviewLane.x"
                          :y="conveyorPreviewLane.y"
                          :width="conveyorPreviewLane.railWidth"
                          :height="conveyorPreviewLane.height"
                          rx="6"
                          ry="6"/>
                    <rect class="conveyor-preview-rail"
                          :x="conveyorPreviewLane.deckX + conveyorPreviewLane.deckWidth"
                          :y="conveyorPreviewLane.y"
                          :width="conveyorPreviewLane.railWidth"
                          :height="conveyorPreviewLane.height"
                          rx="6"
                          ry="6"/>
                    <line class="conveyor-preview-flow"
                          :x1="conveyorPreviewLane.flowX"
                          :y1="conveyorPreviewLane.y + 80"
                          :x2="conveyorPreviewLane.flowX"
                          :y2="conveyorPreviewLane.y + conveyorPreviewLane.height - 80"
                          :marker-end="'url(#' + conveyorPreviewSvgIds.flowArrow + ')'"/>
                    <polyline v-for="(mark, index) in conveyorPreviewLane.flowMarks"
                              :key="'conveyor-preview-flow-' + index"
                              class="conveyor-preview-flow-mark"
                              :points="mark"/>
                    <line class="conveyor-preview-reference"
                          :x1="conveyorPreviewLane.referenceX"
                          :y1="conveyorPreviewLane.y"
                          :x2="conveyorPreviewLane.referenceX"
                          :y2="conveyorPreviewLane.y + conveyorPreviewLane.height"/>
                    <g class="conveyor-preview-axis">
                      <circle class="conveyor-preview-origin"
                              :cx="conveyorPreviewLane.referenceX"
                              :cy="conveyorPreviewLane.originY"
                              r="8"/>
                      <line class="conveyor-preview-axis-x"
                            :x1="conveyorPreviewLane.referenceX"
                            :y1="conveyorPreviewLane.originY"
                            :x2="conveyorPreviewLane.referenceX"
                            :y2="conveyorPreviewLane.originY - conveyorPreviewLane.xAxis"
                            :marker-end="'url(#' + conveyorPreviewSvgIds.xArrow + ')'"/>
                      <line class="conveyor-preview-axis-y"
                            :x1="conveyorPreviewLane.referenceX"
                            :y1="conveyorPreviewLane.originY"
                            :x2="conveyorPreviewLane.referenceX + conveyorPreviewLane.yAxis"
                            :y2="conveyorPreviewLane.originY"
                            :marker-end="'url(#' + conveyorPreviewSvgIds.yArrow + ')'"/>
                      <text class="conveyor-preview-axis-label-x"
                            :x="conveyorPreviewLane.referenceX + 8"
                            :y="conveyorPreviewLane.originY - conveyorPreviewLane.xAxis - 8">x</text>
                      <text class="conveyor-preview-axis-label-y"
                            :x="conveyorPreviewLane.referenceX + conveyorPreviewLane.yAxis + conveyorPreviewLane.yLabelOffset"
                            :y="conveyorPreviewLane.originY - 8">y</text>
                    </g>
                    <g v-for="pick in conveyorPreviewPicks"
                       :key="'conveyor-preview-pick-' + pick.id"
                       :class="{ 'conveyor-preview-pick-current': pick.current }">
                      <g v-for="box in pick.boxes"
                         :key="'conveyor-preview-box-' + pick.id + '-' + box.id">
                        <rect class="conveyor-preview-box-face"
                              :x="box.x"
                              :y="box.y"
                              :width="box.width"
                              :height="box.height"
                              rx="4"
                              ry="4"/>
                        <rect class="conveyor-preview-box-outline"
                              :x="box.x"
                              :y="box.y"
                              :width="box.width"
                              :height="box.height"
                              rx="3"
                              ry="3"/>
                        <rect v-for="label in box.labels"
                              :key="'conveyor-preview-label-' + pick.id + '-' + box.id + '-' + label.id"
                              class="conveyor-preview-label"
                              :x="label.x"
                              :y="label.y"
                              :width="label.width"
                              :height="label.height"
                              :fill="conveyorPreviewLabelColor"/>
                      </g>
                      <g class="conveyor-preview-gripper-overlay"
                         :transform="pick.gripper.transform">
                        <rect class="conveyor-preview-gripper"
                              :x="pick.gripper.x"
                              :y="pick.gripper.y"
                              :width="pick.gripper.width"
                              :height="pick.gripper.height"
                              rx="6"
                              ry="6"/>
                        <line class="conveyor-preview-gripper-axis-x"
                              :x1="pick.gripper.centerX"
                              :y1="pick.gripper.centerY"
                              :x2="pick.gripper.centerX"
                              :y2="pick.gripper.centerY - pick.gripper.axisX"
                              :marker-end="'url(#' + conveyorPreviewSvgIds.xArrow + ')'"/>
                        <text class="conveyor-preview-gripper-axis-label conveyor-preview-gripper-axis-label-x"
                              :x="pick.gripper.centerX + 8"
                              :y="pick.gripper.centerY - pick.gripper.axisX - 8">x</text>
                        <line class="conveyor-preview-gripper-axis-y"
                              :x1="pick.gripper.centerX"
                              :y1="pick.gripper.centerY"
                              :x2="pick.gripper.centerX - pick.gripper.axisY"
                              :y2="pick.gripper.centerY"
                              :marker-end="'url(#' + conveyorPreviewSvgIds.yArrow + ')'"/>
                        <text class="conveyor-preview-gripper-axis-label conveyor-preview-gripper-axis-label-y"
                              :x="pick.gripper.centerX - pick.gripper.axisY - 24"
                              :y="pick.gripper.centerY - 8">y</text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </v-flex>
            <v-spacer v-if="showMoveControls"/>
            <div :style="hiddenStyle">
              <ControlButtons :disabled="!canMoveControls" @move="handleMove" id="controls"/>
            </div>
          </v-layout>
        </div>

        <!-- Sequence Panel -->
        <div v-if="isCustomSolution() && side === 'L'" style="flex: 0 0 auto;">
          <SequencePanel
              :boxes="boxPositions"
              :sequences="sequences"
              :box="box"
              :program-settings="programSettings"
              :current-pick-selection="currentPickSelection"
              :selected-box="selectedBox"
              :gripper-length="machineSettings.gripperSettings.gripperLength"
              :gripper-width="machineSettings.gripperSettings.gripperWidth"
              :vacuum-sections="machineSettings.numberOfVacuumSections || 1"
              :vacuum-section-selection-enabled="machineSettings.vacuumSectionSelectionEnabled === true"
              :pallet-rotation="palletDisplayRotation"
              :sequence-box-selection="sequenceBoxSelection"
              :current-sequence-id="currentSequenceId"
              @selecting="setSequenceBoxSelection"
              @sequences="updateSequences"
              @sequenceSelection="updateSequenceSelection"
              @pickSelection="updatePickSelection"
              @gripperOverlay="showGripperOverlay"
          />
        </div>
      </v-flex>

      <!-- Rotate Pallet View -->
      <v-flex shrink v-if="isCustomSolution()" class="workspace-bottom">
        <v-layout row align-center justify-center fill-height>
          <v-flex grow/>
          <v-flex shrink>
            <span>{{ $t("patternStep.rotatePalletView") }}</span>
            <v-btn id="btn-rotate-ccw" flat @click.native="rotatePalletCCW()" class="btn-rotate-pv">
              <v-icon>rotate_90_degrees_ccw</v-icon>
            </v-btn>
            <v-btn id="btn-rotate-cw" flat @click.native="rotatePalletCW()" class="btn-rotate-pv">
              <v-icon>rotate_90_degrees_cw</v-icon>
            </v-btn>
          </v-flex>
          <v-flex grow/>
        </v-layout>
      </v-flex>

      <!-- Alerts -->
      <v-flex shrink>
        <v-alert v-if="getAlertItems().length > 1" id="alert-multiple" :value="hasPatternIssues()" type="warning"
                 @click="showBottomSheet = true">
          {{ $t("patternStep.alertMultipleIssues") }}
        </v-alert>
        <v-alert v-if="getAlertItems().length === 1" :id="'alert-' + getAlertItems()[0].id"
                 :value="hasPatternIssues()" type="warning">
          {{ getAlertItems()[0].description }}
        </v-alert>
      </v-flex>

      <v-flex shrink>
        <v-bottom-sheet v-model="showBottomSheet">
          <v-list>
            <v-subheader>Explanation of issues in current pattern:</v-subheader>
            <v-list-tile
                v-for="(item, i) in getAlertItems()"
                :key="i"
                @click="showBottomSheet = false"
            >
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ item.description }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-bottom-sheet>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showIgnoreGripperConfirmation" persistent max-width="350">
      <v-card raised>
        <v-card-title class="subheading">{{
            $t("patternStep.titleGripperWarning", [this.disableGripperWarning ? $t("patternStep.disable") : $t("patternStep.enable")])
          }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="this.disableGripperWarning">{{ $t("patternStep.textGripperWarningDisable") }}
        </v-card-text>
        <v-card-text v-else>{{ $t("patternStep.textGripperWarningEnable") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmGripperWarning(false)">{{ $t("general.confirm") }}</v-btn>
          <v-btn flat @click="confirmGripperWarning(true)">{{ $t("general.confirmAll") }}</v-btn>
          <v-btn flat @click="showIgnoreGripperConfirmation = false">{{ $t("general.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogCenterIssues" persistent max-width="350">
      <v-card raised>
        <v-card-title class="subheading">{{ $t("patternStep.centerGripperIssuesTitle") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>{{ $t("patternStep.centerGripperIssuesText") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmCenter(true)">{{ $t("patternStep.ungroup") }}</v-btn>
          <v-btn flat @click="confirmCenter(false)">{{ $t("patternStep.continue") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showIgnoreRotationConfirmation" persistent max-width="350">
      <v-card raised>
        <v-card-title class="subheading">{{
            $t("patternStep.titleRotationWarning", [this.disableRotationWarning ? $t("patternStep.disable") : $t("patternStep.enable")])
          }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="this.disableRotationWarning">{{ $t("patternStep.textRotationWarningDisable") }}
        </v-card-text>
        <v-card-text v-else>{{ $t("patternStep.textRotationWarningEnable") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmRotationWarning(false)">{{ $t("general.confirm") }}</v-btn>
          <v-btn flat @click="confirmRotationWarning(true)">{{ $t("general.confirmAll") }}</v-btn>
          <v-btn flat @click="showIgnoreRotationConfirmation = false">{{ $t("general.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showRightPalletModeConfirmation" persistent max-width="350">
      <v-card raised>
        <v-card-title class="subheading">{{ $t("patternStep.titleLayerOptionConfirmation") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>{{ $t("patternStep.textLayerOptionConfirmation") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="btn-cancel-rpm" flat @click="confirmRightPalletMode(false)">{{ $t("general.cancel") }}</v-btn>
          <v-btn id="btn-confirm-rpm" flat @click="confirmRightPalletMode(true)">{{ $t("patternStep.continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
/* tslint:disable */
import { PatternEditor } from '@/libs/pattern/patternEditor'
import { PatternCanvas } from '@/libs/pattern/patternCanvas'
import Vue from 'vue'
import { hasRotationLimitations, isRI20 } from '@/libs/pattern/gripperUtils'
import ControlButtons from '@/components/ControlButtons'
import SequencePanel from '@/components/SequencePanel.vue'
import { RobotTypeEnum } from '@/generated/model/robotTypeEnum'
import { findSequenceByBoxId } from '@/libs/pattern/sequenceUtils'
import { hasRightPalletModeOption } from '@/libs/pattern/robotUtils'
import { mapGetters } from 'vuex'
import { boxBorderWidth, labelColor } from '@/libs/pattern/pattern-editor-constants'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'LayerPatternComponent',
  components: {SequencePanel, ControlButtons},
  computed: {
    ...mapGetters('settings',  ['isPatternGenerationEnabled']),
    ...mapGetters('patterngeneration', ['patternGenResponse', 'patternGenError']),
    isPatternGenAvailable: function () {
      return this.id < 2 && this.side === 'L'
          && this.isPatternGenerationEnabled
          && (this.patternGenResponse && this.patternGenResponse.status === 'ok')
    },
    filteredActions() {
      return this.getFilteredActions()
    },
    showMoveControls() {
      return (this.isCustomSolution() && this.side === 'L') || this.canMoveControls
    },
    canMoveControls() {
      const hasSelectedBox = this.selectedBox != null
          && this.boxPositions.some(p => Number(p.id) === Number(this.selectedBox))
      return this.side === 'L'
          && !this.reorderManuallyMode
          && !this.multiSelect
          && (hasSelectedBox || this.allSelected())
          && !(this.currentPickSelection.length > 0 && this.currentPickSelection.includes(this.selectedBox)
              && !this.isBoxPartOfAnySequence(this.selectedBox))
    },
    hiddenStyle() {
      // Only change opacity, so width is taken into account even if not visible
      return { opacity: this.showMoveControls ? 1 : 0 }
    },
    conveyorPreviewSvgIds() {
      const suffix = this._uid || 'preview'
      return {
        xArrow: `conveyor-preview-x-arrow-${suffix}`,
        yArrow: `conveyor-preview-y-arrow-${suffix}`,
        flowArrow: `conveyor-preview-flow-arrow-${suffix}`
      }
    },
    conveyorPreviewViewBox() {
      const lane = this.conveyorPreviewLane
      const layout = this.getConveyorPreviewLayout()
      const paddingX = Math.max(70, layout.gripperWidth / 2 + 20)
      const paddingY = Math.max(100, layout.gripperLength / 2 + 20)
      let minX = lane.x - paddingX
      let minY = lane.y - paddingY
      let maxX = lane.x + lane.width + paddingX
      let maxY = lane.y + lane.height + paddingY
      this.getConveyorPreviewPicks(this.getConveyorPreviewViewportSourcePicks()).forEach(pick => {
        const bounds = this.getConveyorPreviewGripperBounds(pick.gripper)
        minX = Math.min(minX, bounds.minX - 20)
        minY = Math.min(minY, bounds.minY - 20)
        maxX = Math.max(maxX, bounds.maxX + 20)
        maxY = Math.max(maxY, bounds.maxY + 20)
      })
      return `${Math.floor(minX)} ${Math.floor(minY)} ${Math.ceil(maxX - minX)} ${Math.ceil(maxY - minY)}`
    },
    conveyorPreviewLane() {
      const layout = this.getConveyorPreviewLayout()
      const midX = layout.railWidth + layout.conveyorWidth / 2
      const flowMarks = [0.28, 0.48, 0.68].map(position => {
        const y = layout.conveyorLength * position
        return `${midX - 36},${y - 20} ${midX},${y + 18} ${midX + 36},${y - 20}`
      })
      return {
        x: 0,
        y: 0,
        deckX: layout.railWidth,
        deckWidth: layout.conveyorWidth,
        railWidth: layout.railWidth,
        width: layout.conveyorTotalWidth,
        height: layout.conveyorLength,
        referenceX: layout.referenceX,
        originY: layout.conveyorLength,
        xAxis: 90,
        yAxis: -90,
        yLabelOffset: -34,
        flowX: midX,
        flowMarks: flowMarks
      }
    },
    conveyorPreviewLabelColor() {
      return labelColor
    },
    conveyorPreviewPicks() {
      return this.getConveyorPreviewPicks(this.getConveyorPreviewSourcePicks())
    }
  },
  props: {
    box: {type: Object, default: () => ({})},
    pallet: {type: Object, default: () => ({})},
    labelPosition: {type: String, default: 'FRONT'},
    initialBoxPositions: {type: Array, default: () => []},
    initialBoxGroups: {type: Array, default: () => []},
    initialGripperSections: {type: Array, default: () => []},
    initialPusherGroups: {type: Array, default: () => []},
    initialIgnoreGripperList: {type: Array, default: () => []},
    initialIgnoreRotationList: {type: Array, default: () => []},
    initialRightPalletMode: {type: String, default: 'copy'},
    initialValidationResult: {type: Object, default: () => ({})},
    initialSequences: {type: Array, default: () => []},
    programSettings: {type: Object, default: () => ({})},
    machineSettings: {type: Object, default: () => ({})},
    id: {type: Number, default: 0},
    side: {type: String, default: ''},
    mode: {type: String, default: 'full'},
    snapshot: {type: Number, default: 0},
    parentBus: Vue
  },

  data: function () {
    return {
      isSnap: true,
      autoOrder: true,
      multiSelect: false,
      // multiPick: false,
      multiPickOk: false,
      ignoreGripperOutside: false,
      swapOk: false,
      editor: null,
      view: null,
      mouseHandlers: {down: null, up: null, dblClick: null, over: null, out: null},
      showSheet: false,
      boxPositions: this.initialBoxPositions,
      boxGroups: this.initialBoxGroups,
      boxDefinition: this.box,
      palDef: {width: 0, height: 0, overhangL: 0, overhangB: 0, overhangR: 0, overhangT: 0},
      boxDef: {width: 0, height: 0, labelPos: this.labelPosition, widthMargin: 0, lengthMargin: 0},
      palPos: {topLeftX: 300, topLeftY: 40, dropZoneX: 300},
      templateScalefac: 1.0,
      reorderManuallyMode: false,
      hasGripperIssues: false,
      groupPlacementOverlap: false,
      groupPlacementCollision: false,
      hasRotationIssues: false,
      groupSelection: false,
      groupWithPusher: false,
      showIgnoreGripperConfirmation: false,
      disableGripperWarning: false,
      showDialogCenterIssues: false,
      centerIssues: [],
      ignoreRotationLimit: false,
      showIgnoreRotationConfirmation: false,
      disableRotationWarning: false,
      groups: [],
      groupPlacementOverlap2: false,
      overlappingGroups: new Map(),
      selectedBox: 0,
      selectedBoxes: [],
      rightPalletSelectionItems: [
        {
          value: 'copy',
          text: `${this.$t('patternStep.copy')}`,
          icon: 'file_copy',
          iconStyle: ''
        },
        {
          value: 'mirrorLeftX',
          text: `${this.$t('patternStep.mirrorByX')}`,
          icon: 'flip',
          iconStyle: 'transform: rotate(90deg)'
        },
        {
          value: 'mirrorLeftY',
          text: `${this.$t('patternStep.mirrorByY')}`,
          icon: 'flip',
          iconStyle: ''
        }
      ],
      rightPalletMode: this.initialRightPalletMode,
      showRightPalletModeConfirmation: false,
      cancelChangeMode: false,
      validationResult: this.initialValidationResult,
      showBottomSheet: false,
      palletDisplayRotation: (this.isCustomSolution() && this.pallet.displayRotation) ? this.pallet.displayRotation : 0,
      sequences: this.initialSequences || [],
      sequenceBoxSelection: false,
      currentPickSelection: this.setInitialPickSelection(),
      currentSequenceId: 1,
      availableStrategies: [],
      selectedStrategy: null,
      availableSymmetries: [],
      selectedSymmetry: null,
      selGeneratedBoxPositions: [],
      preserveCurrentPickSelectionOnSequenceUpdate: false
    }
  },

  watch: {
    id: function () {
      // console.log('LayerPatternComponentV2.id changed: ', this.id)
      this.groupPlacementCollision = false // reset when switching pattern
      this.selGeneratedBoxPositions.length = 0
      this.$nextTick(() => {
        if (this.isCustomSolution() && this.side === 'L') {
          this.sequences = this.initialSequences || []
          this.preserveCurrentPickSelectionOnSequenceUpdate = false
          this.currentPickSelection = this.setInitialPickSelection()
          this.currentSequenceId = 1
          this.sequenceBoxSelection = false
        }
        this.drawLayer()
      })
    },
    snapshot: function () {
      // console.log('LayerPatternComponentV2.snapshot changed')
      this.$nextTick(() => {
        this.drawLayer()
      })
    },
    initialSequences: {
      handler: function () {
        if (!this.isCustomSolution() || this.side !== 'L') {
          return
        }
        this.$nextTick(() => {
          const currentPickSelection = [...this.currentPickSelection]
          const incomingSequences = this.initialSequences || []
          if (this.sequenceBoxSelection) {
            if (this.view) {
              this.view.updateSequences(this.sequences)
              this.view.selectCollection(this.currentPickSelection)
            }
            return
          }
          if (this.preserveCurrentPickSelectionOnSequenceUpdate &&
              this.hasPickSelection(this.sequences, currentPickSelection) &&
              !this.hasPickSelection(incomingSequences, currentPickSelection)) {
            if (this.view) {
              this.view.updateSequences(this.sequences)
              this.view.selectCollection(this.currentPickSelection)
            }
            return
          }
          this.sequences = incomingSequences
          if (this.hasPickSelection(this.sequences, currentPickSelection)) {
            this.currentPickSelection = currentPickSelection
          } else {
            this.currentPickSelection = this.setInitialPickSelection()
          }
          this.preserveCurrentPickSelectionOnSequenceUpdate = false
          if (this.view) {
            this.view.updateSequences(this.sequences)
            this.view.selectCollection(this.currentPickSelection)
          }
        })
      },
      deep: true
    },
    initialRightPalletMode: function () {
      this.rightPalletMode = this.initialRightPalletMode
    },
    rightPalletMode: function () {
      this.setRightPalletMode()
    },
    'initialValidationResult.lpbuId': function() {
      this.validationResult = this.initialValidationResult
      this.editor.showValidationResult(this.validationResult.lpbuId || 0)
    },
    patternGenResponse: function() {
      if (this.id > 1 || this.side === 'R') { // skip for Z layer and right side
        return
      }
      this.populateStrategies()
      this.populateSymmetries()
    }
  },

  mounted () {
    // console.log('[DEBUG] LayoutComponentV2 mounted', this.id, this.side)
    if (this.side === 'R') {
      this.autoOrder = false
      this.multiSelect = false //true
    }
    const options = {autoOrder: this.autoOrder, multiSelect: this.multiSelect, side: this.side}

    const immutablePallet = JSON.parse(JSON.stringify(this.pallet))
    if (!this.isCustomSolution()) {
      immutablePallet.displayRotation = 0
    }

    // noinspection JSCheckFunctionSignatures
    this.view = new PatternCanvas('paledit' + this.side, 'pallet_canvas' + this.side, this.box, immutablePallet,
      this.programSettings, {shadow: true, snapRulers: true, side: this.side, mode: this.mode})

    // noinspection JSCheckFunctionSignatures
    this.editor = new PatternEditor(this.box, immutablePallet, this.programSettings, this.machineSettings, this.view, options)

    // react on external event "Next" button and save current state from editor
    this.parentBus.$on('stepper_next', this.editor.save())

    this.updateAutoOrder()
    this.showIgnoreGripperConfirmation = false
    this.disableGripperWarning = false

    if (this.isPatternGenAvailable) {
      this.populateStrategies()
      this.populateSymmetries()
    }

    this.view.init()
      .then(() => {
        this.editor.on('gripperIssues', (value) => {
          this.$emit('layerIssues', value, this.id, 'gripper')
          this.hasGripperIssues = value
        })
        this.editor.on('ignoredIssues', (value, type) => {
          this.$emit('ignoredIssues', value, this.id, type)
        })
        this.editor.on('rotationIssues', (value) => {
          this.$emit('layerIssues', value, this.id, 'rotation')
          this.hasRotationIssues = value
        })
        this.editor.on('overlappingGroups', (value) => {
          // console.log('on overlappingGroups ', value, this.side, this.id)
          this.groupPlacementOverlap2 = value.size > 0
          this.$emit('layerIssues', this.groupPlacementOverlap2, this.id, 'overlap')
          this.overlappingGroups = value
        })
        this.editor.on('group_placement_overlap', (value) => {
          this.groupPlacementOverlap = value
        })
        this.editor.on('group_placement_collision', (value) => {
          this.groupPlacementCollision = value
        })
        this.drawLayer()
        this.editor.on('save', (state) => {
          // console.log('[DEBUG] LayoutComponentV2 saving', JSON.stringify(state.positions))
          this.boxPositions = [...state.positions]
          if (this.isPatternGenAvailable && this.selectedStrategy !== null
              && !(this.boxPositions.length === this.selGeneratedBoxPositions.length
                  && this.boxPositions.every(bp => this.selGeneratedBoxPositions.find(s => s.id === bp.id && s.x === bp.x && s.y === bp.y && s.rotation === bp.rotation) != null)
              )) {
            this.resetGeneratedPatternPlan()
          }
          this.$emit('save', state)
        })
        this.saveState()
        this.editor.on('multiPlace', (value) => {
          this.multiPickOk = value
        })
        this.editor.on('swapOk', (value) => {
          this.swapOk = value
        })
        this.editor.on('manual_reorder_finished', () => {
          // console.log('[DEBUG] LayoutComponentV2', 'manual_reorder_finished')
          this.$emit('reorderManuallyActivated', false)
          this.reorderManuallyMode = false
        })
        this.editor.on('show_confirm_ignore_gripper', (value) => {
          this.showIgnoreGripperConfirmation = true
          this.disableGripperWarning = value
        })
        this.editor.on('show_confirm_ignore_rotation', (value) => {
          this.showIgnoreRotationConfirmation = true
          this.disableRotationWarning = value
        })
        this.editor.on('checkIgnoreGripper', (value) => {
          this.ignoreGripperOutside = value
        })
        this.editor.on('checkIgnoreRotation', (value) => {
          this.ignoreRotationLimit = value
        })
        this.editor.on('groupSelection', (value) => {
          this.groupSelection = value
        })
        this.editor.on('groupWithPusher', (value) => {
          this.groupWithPusher = value
        })
        this.editor.on('groups', (value) => {
          this.groups = value
        })
        this.editor.on('selected', (id) => {
          this.selectedBox = id
        })
        this.editor.on('selectedMulti', (ids) => {
          this.selectedBoxes = ids
        })
      })
  },

  beforeDestroy() {
    this.view.destroy()
  },

  methods: {
    drawLayer () {
      this.updateAutoOrder()
      // console.log('[DEBUG] draw layer', this.id, this.side, this.autoOrder)
      // console.log(JSON.stringify(this.initialBoxPositions, null, '  '))
      if (this.isCustomSolution() && this.side === 'L') {
        const currentPickSelection = [...this.currentPickSelection]
        if (this.sequenceBoxSelection || this.hasPickSelection(this.sequences, currentPickSelection)) {
          this.currentPickSelection = currentPickSelection
        } else {
          this.sequences = this.initialSequences || []
          this.currentPickSelection = this.setInitialPickSelection()
        }
      }
      this.boxPositions = (this.isPatternGenerationEnabled && this.selGeneratedBoxPositions.length > 0)
          ? this.selGeneratedBoxPositions : this.initialBoxPositions
      this.editor.autoOrder = this.autoOrder
      this.editor.applyState({
        positions: JSON.parse(JSON.stringify(this.boxPositions)),
        groups: this.initialBoxGroups,
        gripperSections: this.initialGripperSections,
        pusherGroups: this.initialPusherGroups,
        ignoreGripperBoxes: this.initialIgnoreGripperList,
        ignoreRotationBoxes: this.initialIgnoreRotationList
      }, false, true)
      this.editor.showValidationResult(this.validationResult.lpbuId || 0)
      if (this.isCustomSolution()) {
        this.view.updateSequences(this.sequences)
        this.view.selectCollection(this.currentPickSelection)
      }
    },

    setSnap (value) {
      this.editor.setSnapMode(value)
    },

    setAutoOrder (value) {
      if (this.side === 'L') {
        this.pallet.layerPatterns[this.id].manualOrder = !value
      }else if (this.side === 'R') {
        this.pallet.layerPatterns[this.id].manualOrderAlt = !value
      }

      if (value && this.reorderManuallyMode) {
        // abort reorderManuallyMode if the user ticks the auto order checkbox
        this.reorderManually(false)
      }
      this.editor.setAutoOrder(value)
    },

    setMultiSelect (value) {
      this.editor.setMultiSelect(value)
    },

    setIgnoreGripperOutside (value) {
      this.editor.setIgnoreGripperOutside(value)
    },

    setIgnoreBoxRotation (value) {
      this.editor.setIgnoreBoxRotation(value)
    },

    autofill () {
      this.editor.autofill()
    },

    center() {
      this.centerIssues = this.editor.canCenter()
      if (this.centerIssues.length > 0) {
        this.showDialogCenterIssues = true
      }else{
        this.editor.center()
      }
    },

    clear () {
      this.editor.clear()
    },

    rotateBox () {
      const angle = this.side === 'L' ? 90 : 180
      this.editor.rotate(angle)
    },

    deleteBox () {
      this.editor.delete()
    },

    group () {
      this.editor.makeGroup(this.groupWithPusher)
    },

    ungroup () {
      this.editor.destroyGroup()
    },

    reorderManually (active) {
      if (this.side === 'L') {
        this.pallet.layerPatterns[this.id].manualOrder = active
      }
      if (this.side === 'R') {
        this.pallet.layerPatterns[this.id].manualOrderAlt = active
      }
      console.debug('[DEBUG] reorder manually', active, this.id, this.side, this.pallet.layerPatterns.map(p => p.manualOrder))
      this.reorderManuallyMode = active
      this.editor.reorderManually(active)
      this.$emit('reorderManuallyActivated', active)
      if (active) {
        this.$emit('manualOrderChanged', {side: this.side, id: this.id})
      }
    },

    selectAll() {
      this.editor.selectAll()
    },

    deselectAll() {
      this.editor.deselectAll()
    },

    saveState() {
      this.editor.save()
      const args = 'L' === this.side
          ? [this.editor.getState(), this.sequences]
          : [this.editor.getState()]
      this.$emit('save', ...args)
    },

    confirmGripperWarning (all) {
      if (all) {
        this.editor.handleGripperWarningAll()
      } else {
        this.editor.handleGripperWarning()
      }
      this.showIgnoreGripperConfirmation = false
    },

    confirmRotationWarning(all) {
      if (all) {
        this.editor.handleRotationWarningAll()
      } else {
        this.editor.handleRotationWarning()
      }
      this.showIgnoreRotationConfirmation = false
    },

    resetGroups(features) {
      this.editor.resetGroups(features)
    },

    autoResolveGripperIssues() {
      this.editor.autoResolveGripperIssues()
    },

    canAllAutoRotate(){
      return this.editor.canAllAutoRotate()
    },

    confirmCenter(resetGroups) {
      if(resetGroups) {
        this.editor.resetGroupsByPos(this.centerIssues)
      }
      this.editor.center()
      this.showDialogCenterIssues = false
      this.centerIssues = []
      this.view.updateSequences(this.sequences)
    },

    showIgnoreBoxRotation(){
      return hasRotationLimitations(this.machineSettings.robotType, this.machineSettings.gripperSettings.gripperType)
    },

    showIgnoreGripper() {
      return isRI20(this.machineSettings.robotType) && isRI20(this.programSettings.robotType)
    },

    updateAutoOrder() {
      if (this.side === 'L') {
        this.autoOrder = !this.pallet.layerPatterns[this.id].manualOrder
      }
      if (this.side === 'R') {
        this.autoOrder = !this.pallet.layerPatterns[this.id].manualOrderAlt
      }
    },

    getOverlapWarningText() {
      if(!this.overlappingGroups) {
        return ''
      }else{
        const movement = Array.from(this.overlappingGroups.keys())
        return `${this.$t('patternStep.groupOverlapGroupConfig', [movement])}`
      }
    },

    handleMove(direction) {
      if (!this.canMoveControls) {
        return
      }
      const sequence = findSequenceByBoxId(this.selectedBox, this.sequences)
      const sequenceBoxIds = sequence ? sequence.pick.flatMap(p => p.boxesGroup || []).map(Number) : undefined
      const firstBoxBefore = sequenceBoxIds ? this.boxPositions.find(p => p.id === sequenceBoxIds[0]) : null
      const before = firstBoxBefore ? { id: firstBoxBefore.id, x: firstBoxBefore.x, y: firstBoxBefore.y } : null

      this.editor.moveSelected(direction, sequenceBoxIds)

      const firstBoxAfter = before ? this.boxPositions.find(p => p.id === before.id) : null
      if (!sequence || !before || !firstBoxAfter) {
        return
      }

      const dx = firstBoxAfter.x - before.x
      const dy = firstBoxAfter.y - before.y
      if (dx === 0 && dy === 0) {
        return
      }

      const sequences = JSON.parse(JSON.stringify(this.sequences))
      const movedSequence = sequences.find(s => s.id === sequence.id)
      const place = movedSequence && movedSequence.place && movedSequence.place[0]
      if (!place) {
        return
      }
      if (place.x != null) {
        place.x += dx
      }
      if (place.y != null) {
        place.y += dy
      }
      this.sequences = sequences
      this.view.updateSequences(this.sequences)
      this.saveState()
    },

    isBoxPartOfAnySequence(id) {
      return id != null && id > 0 && findSequenceByBoxId(id, this.sequences) != null
    },

    isAnySequence() {
      return this.sequences != null && this.sequences.length > 0
    },

    deleteAndRotateBoxAreDisabled() {
      return this.multiPickOk || this.reorderManuallyMode || this.allSelected() ||
          this.isBoxPartOfAnySequence(this.selectedBox) ||
          this.currentPickSelection.includes(this.selectedBox)
    },

    allSelected() {
      return this.boxPositions.length > 0
          && this.boxPositions.length === this.selectedBoxes.length
    },

    setRightPalletMode() {
      if (this.groups.some(bg => bg.length > 0)
          || this.boxGroups.some(bg => bg.length > 0)) {
        this.showRightPalletModeConfirmation = !this.cancelChangeMode
      } else {
        this.confirmRightPalletMode(true)
      }
      this.cancelChangeMode = false
    },

    showMirrorLayerOptions() {
      return hasRightPalletModeOption(this.programSettings.robotType)
    },

    confirmRightPalletMode(value) {
      if (value) {
        this.$emit('rightPalletMode', this.rightPalletMode)
      } else {
        this.cancelChangeMode = true
        this.rightPalletMode = this.initialRightPalletMode
      }
      this.showRightPalletModeConfirmation = false
    },

    clearValidationStatus() {
      this.validationResult.lpbuId = 0
      this.editor.showValidationResult(0)
    },

    hasPatternIssues() {
      return this.hasGripperIssues
          || this.hasRotationIssues
          || this.groupPlacementCollision
          || this.groupPlacementOverlap
          || this.groupPlacementOverlap2
          || (this.validationResult && this.validationResult.lpbuId > 0)
          || (this.isPatternGenerationEnabled && this.patternGenError != null)
    },

    getAlertItems() {
      const alertItems = []
      if (this.hasGripperIssues) {
        alertItems.push({
          description: String(this.$t("patternStep.issuesGripper")),
          icon: 'info',
          id: 'gripper-issues'
        })
      }
      if (this.hasRotationIssues) {
        alertItems.push({
          description: String(this.$t("patternStep.issuesRotation")),
          icon: 'redo',
          id: 'rotation-issues'
        })
      }
      if (this.groupPlacementOverlap) {
        alertItems.push({
          description: String(this.$t("patternStep.groupOverlap")),
          icon: 'clear',
          id: 'group-overlap'
        })
      }
      if (this.groupPlacementCollision) {
        alertItems.push({
          description: String(this.$t("patternStep.groupCollision")),
          icon: 'clear',
          id: 'group-collision'
        })
      }
      if (this.groupPlacementOverlap2) {
        alertItems.push({
          description: this.getOverlapWarningText(),
          icon: 'clear',
          id: 'group-overlap2'
        })
      }
      if (this.validationResult && this.validationResult.lpbuId > 0) {
        alertItems.push({
          description: `${this.$t('patternStep.validationInfo', [this.validationResult.layerNo])}`,
          icon: 'unpublished',
          id: 'validation-error'
        })
      }
      if (this.isPatternGenerationEnabled && this.patternGenError != null) {
        const message = (this.patternGenError.message != null) ? this.patternGenError.message : this.patternGenError
        alertItems.push({
          description: `Pattern Generation: ${message}`,
          icon: 'unpublished',
          id: 'pattern-generation-error'
        })
      }
      return alertItems
    },

    isCustomSolution() {
      return RobotTypeEnum.CUSTOM_SOLUTION === this.programSettings.robotType
    },

    showConveyorPreview() {
      return this.isCustomSolution() && this.side === 'L'
    },

    getConveyorConfiguration() {
      return this.programSettings.conveyorConfiguration || this.machineSettings.conveyorConfiguration || 'CENTER_RIGHT'
    },

    getConveyorPreviewSequence() {
      if (!this.sequences || this.sequences.length === 0) {
        return null
      }
      return this.sequences.find(s => Number(s.id) === Number(this.currentSequenceId)) || this.sequences[0]
    },

    getConveyorPreviewSourcePicks() {
      const sequence = this.getConveyorPreviewSequence()
      const picks = sequence && sequence.pick
          ? sequence.pick
            .filter(pick => pick && pick.boxesGroup && pick.boxesGroup.length > 0)
            .map(pick => this.getConveyorPreviewPickWithOffset(pick, sequence))
          : []
      if (this.sequenceBoxSelection && this.currentPickSelection.length > 0
          && !picks.some(pick => this.sameBoxes(pick.boxesGroup, this.currentPickSelection))) {
        picks.push(this.getConveyorPreviewPickWithOffset({
          id: 'selection',
          boxesGroup: [...this.currentPickSelection],
          zRot: 0
        }, sequence))
      }
      if (picks.length < 2) {
        return picks
      }
      const currentPick = picks.find(pick => this.sameBoxes(pick.boxesGroup, this.currentPickSelection))
      return [currentPick || picks[0]]
    },

    getConveyorPreviewViewportSourcePicks() {
      const picks = (this.sequences || [])
          .flatMap(sequence => sequence && sequence.pick
            ? sequence.pick
              .filter(pick => pick && pick.boxesGroup && pick.boxesGroup.length > 0)
              .map(pick => this.getConveyorPreviewPickWithOffset(pick, sequence))
            : [])
      if (this.sequenceBoxSelection && this.currentPickSelection.length > 0
          && !picks.some(pick => this.sameBoxes(pick.boxesGroup, this.currentPickSelection))) {
        picks.push(this.getConveyorPreviewPickWithOffset({
          id: 'selection',
          boxesGroup: [...this.currentPickSelection],
          zRot: 0
        }, this.getConveyorPreviewSequence()))
      }
      return picks
    },

    getConveyorPreviewPickWithOffset(pick, sequence) {
      return {
        ...pick,
        gripperOffsetX: sequence ? sequence.gripperOffsetX : 0,
        gripperOffsetY: sequence ? sequence.gripperOffsetY : 0
      }
    },

    getConveyorPreviewPicks(picks) {
      const layout = this.getConveyorPreviewLayout()
      const labels = this.getConveyorPreviewLabels(layout.boxLength, layout.boxWidth)
      return picks.map((pick, index) => {
        const boxesGroup = pick.boxesGroup || []
        const boxFrameMinY = layout.referenceOnRight ? 0 : -layout.boxWidth
        const boxFrameMaxY = layout.referenceOnRight ? layout.boxWidth : 0
        const sideInsetY = layout.referenceOnRight ? 0 : layout.boxInsetY
        const groupCenterX = boxesGroup.length * layout.boxLength / 2
        const groupCenterY = (boxFrameMinY + boxFrameMaxY) / 2
        const fallbackX = groupCenterX
        const fallbackY = groupCenterY
        const gripperRotation = Number(pick.zRot) || 0
        const gripperOffset = this.getConveyorPreviewGripperOffset(pick, gripperRotation)
        const gripperCenterX = (Number.isFinite(Number(pick.x)) ? Number(pick.x) : fallbackX) + gripperOffset.x
        const gripperCenterY = (Number.isFinite(Number(pick.y)) ? Number(pick.y) : fallbackY) + gripperOffset.y
        const previewGripperCenterX = layout.referenceX - gripperCenterY + sideInsetY
        const previewGripperCenterY = layout.conveyorLength - layout.boxInsetX - gripperCenterX
        return {
          id: pick.id || index + 1,
          current: this.sameBoxes(boxesGroup, this.currentPickSelection),
          boxes: boxesGroup.map((boxId, boxIndex) => {
            const boxModelX = boxIndex * layout.boxLength
            const boxX = layout.referenceX - boxFrameMaxY + sideInsetY
            const boxY = layout.conveyorLength - layout.boxInsetX - boxModelX - layout.boxLength
            return {
              id: boxId,
              x: boxX,
              y: boxY,
              width: layout.boxWidth,
              height: layout.boxLength,
              labels: labels.map(label => ({
                ...label,
                x: boxX + label.y,
                y: boxY + layout.boxLength - label.x - label.width,
                width: label.height,
                height: label.width
              }))
            }
          }),
          gripper: {
            x: previewGripperCenterX - layout.gripperWidth / 2,
            y: previewGripperCenterY - layout.gripperLength / 2,
            width: layout.gripperWidth,
            height: layout.gripperLength,
            centerX: previewGripperCenterX,
            centerY: previewGripperCenterY,
            rotation: gripperRotation,
            axisX: Math.max(25, Math.min(layout.gripperLength / 2, 90)),
            axisY: Math.max(25, Math.min(layout.gripperWidth / 2, 90)),
            transform: `rotate(${gripperRotation} ${previewGripperCenterX} ${previewGripperCenterY})`
          }
        }
      })
    },

    getConveyorPreviewGripperOffset(pick, rotation) {
      const offsetX = Number(pick.gripperOffsetX || 0)
      const offsetY = Number(pick.gripperOffsetY || 0)
      const angle = rotation / 180 * Math.PI
      return {
        x: Math.round(Math.cos(angle) * offsetX - Math.sin(angle) * offsetY),
        y: Math.round(Math.sin(angle) * offsetX + Math.cos(angle) * offsetY)
      }
    },

    getConveyorPreviewGripperBounds(gripper) {
      const angle = gripper.rotation / 180 * Math.PI
      const cos = Math.cos(angle)
      const sin = Math.sin(angle)
      const points = [
        { x: gripper.x, y: gripper.y },
        { x: gripper.x + gripper.width, y: gripper.y },
        { x: gripper.x + gripper.width, y: gripper.y + gripper.height },
        { x: gripper.x, y: gripper.y + gripper.height }
      ].map(point => {
        const x = point.x - gripper.centerX
        const y = point.y - gripper.centerY
        return {
          x: gripper.centerX + x * cos - y * sin,
          y: gripper.centerY + x * sin + y * cos
        }
      })
      return {
        minX: Math.min(...points.map(point => point.x)),
        minY: Math.min(...points.map(point => point.y)),
        maxX: Math.max(...points.map(point => point.x)),
        maxY: Math.max(...points.map(point => point.y))
      }
    },

    getConveyorPreviewLayout() {
      const shortSideLeading = this.programSettings.boxOrientationOnConveyor === 'SHORT_SIDE_LEADING'
      const boxLength = Math.max(1, Number(shortSideLeading ? this.box.length : this.box.width) || 1)
      const boxWidth = Math.max(1, Number(shortSideLeading ? this.box.width : this.box.length) || 1)
      const gripperSettings = this.machineSettings.gripperSettings || {}
      const gripperLength = Math.max(1, Number(gripperSettings.gripperLength || boxLength))
      const gripperWidth = Math.max(1, Number(gripperSettings.gripperWidth || boxWidth))
      const conveyorLength = 900
      const conveyorConfiguration = this.getConveyorConfiguration()
      const isCenterRight = conveyorConfiguration === 'CENTER_RIGHT'
      const referenceOnRight = isCenterRight
      const railWidth = 40
      const conveyorWidth = 400
      const conveyorTotalWidth = conveyorWidth + railWidth * 2
      return {
        conveyorLength: conveyorLength,
        conveyorWidth: conveyorWidth,
        conveyorTotalWidth: conveyorTotalWidth,
        railWidth: railWidth,
        boxLength: boxLength,
        boxWidth: boxWidth,
        gripperLength: gripperLength,
        gripperWidth: gripperWidth,
        boxInsetX: 5,
        boxInsetY: 5,
        isCenterRight: isCenterRight,
        referenceOnRight: referenceOnRight,
        referenceX: referenceOnRight ? railWidth + conveyorWidth : railWidth
      }
    },

    getConveyorPreviewLabels(width, height) {
      const labelPosition = this.programSettings.labelPosition === 'IGNORE'
          ? 'FRONT'
          : this.programSettings.labelPosition || 'FRONT'
      const conveyorLabelPosition = {
        FRONT_RIGHT_CORNER: 'LEFT_FRONT_CORNER',
        RIGHT: 'LEFT',
        RIGHT_BACK_CORNER: 'BACK_LEFT_CORNER',
        BACK_LEFT_CORNER: 'RIGHT_BACK_CORNER',
        LEFT: 'RIGHT',
        LEFT_FRONT_CORNER: 'FRONT_RIGHT_CORNER'
      }[labelPosition] || labelPosition
      const labelLength = Math.min(width, height) / 2
      const labelThickness = Math.max(Math.min(width, height) * 0.08, 16)
      const labels = []
      const addLabel = (left, top, labelWidth, labelHeight) => {
        labels.push({
          id: labels.length,
          x: left - labelWidth / 2 + width / 2,
          y: top - labelHeight / 2 + height / 2,
          width: labelWidth,
          height: labelHeight
        })
      }
      switch (conveyorLabelPosition) {
        case 'FRONT_RIGHT_CORNER':
          addLabel(-width / 2 + labelThickness / 2 + boxBorderWidth, -height / 2 + labelLength / 2 + boxBorderWidth, labelThickness, labelLength)
          addLabel(-width / 2 + labelLength / 2 + boxBorderWidth, -height / 2 + labelThickness / 2 + boxBorderWidth, labelLength, labelThickness)
          break
        case 'RIGHT':
          addLabel(0, -height / 2 + labelThickness / 2, labelLength, labelThickness)
          break
        case 'RIGHT_BACK_CORNER':
          addLabel(width / 2 - labelLength / 2, -height / 2 + labelThickness / 2, labelLength, labelThickness)
          addLabel(width / 2 - labelThickness / 2, -height / 2 + labelLength / 2, labelThickness, labelLength)
          break
        case 'BACK':
          addLabel(width / 2 - labelThickness / 2, 0, labelThickness, labelLength)
          break
        case 'BACK_LEFT_CORNER':
          addLabel(width / 2 - labelLength / 2, height / 2 - labelThickness / 2, labelLength, labelThickness)
          addLabel(width / 2 - labelThickness / 2, height / 2 - labelLength / 2, labelThickness, labelLength)
          break
        case 'LEFT':
          addLabel(0, height / 2 - labelThickness / 2, labelLength, labelThickness)
          break
        case 'LEFT_FRONT_CORNER':
          addLabel(-width / 2 + labelThickness / 2, height / 2 - labelLength / 2, labelThickness, labelLength)
          addLabel(-width / 2 + labelLength / 2, height / 2 - labelThickness / 2, labelLength, labelThickness)
          break
        case 'FRONT':
        default:
          addLabel(-width / 2 + labelThickness / 2 + boxBorderWidth, 0, labelThickness, labelLength)
          break
      }
      return labels
    },

    sameBoxes(a, b) {
      return a && b && a.length === b.length && a.every((id, index) => id === b[index])
    },

    rotatePalletCCW() {
      const current = this.view.rotatePallet(-90)
      if (current !== -1) {
        this.editor.palDef.displayRotation = current
        this.palletDisplayRotation = current
        this.$emit('saveRotation', current)
        this.view.updateSequences(this.sequences)
      }
    },

    rotatePalletCW() {
      const current = this.view.rotatePallet(90)
      if (current !== -1) {
        this.editor.palDef.displayRotation = current
        this.palletDisplayRotation = current
        this.$emit('saveRotation', current)
        this.view.updateSequences(this.sequences)
      }
    },

    setSequenceBoxSelection(value, state, sequences, sequenceId) {
      console.debug('LPC.setSequenceBoxSelection: ', value, JSON.stringify(state), JSON.stringify(sequences))
      this.sequenceBoxSelection = value
      if (sequenceId != null) {
        this.currentSequenceId = sequenceId
      }
      this.editor.deselectAll()
      if (value) {
        this.sequences = [...sequences]
        if (!this.sameBoxes(this.currentPickSelection, state)) {
          this.currentPickSelection = [...state]
        }
        this.view.updateSequences(this.sequences)
        this.view.lockMovement(this.sequenceBoxSelection) // boxes cannot accidentally be moved during selection
      } else {
        // selection done
        this.sequences = [...sequences]
        if (this.isCustomSolution() && this.side === 'L') {
          this.currentPickSelection = [...state]
          this.preserveCurrentPickSelectionOnSequenceUpdate = true
        }
        this.view.deselectCollection(state)
        this.view.clearSelection() // clear single selection
        this.saveState()
        this.view.lockMovement(this.sequenceBoxSelection) // unlock all boxes
        this.view.updateSequences(this.sequences) // locks boxes in sequence
        if (this.isCustomSolution() && this.side === 'L') {
          this.view.selectCollection(this.currentPickSelection)
        }
      }
    },

    updatePickSelection(state) {
      console.debug('LPC.updatePickSelection: ', JSON.stringify(state))
      this.view.deselectCollection(this.currentPickSelection)
      this.currentPickSelection = [...state]
      this.view.selectCollection(this.currentPickSelection)
    },

    updateSequences(sequences) {
      console.debug('LPC.updateSequences: ', JSON.stringify(sequences))
      this.sequences = [...sequences]
      this.view.updateSequences(this.sequences)
      if (this.isCustomSolution() && this.side === 'L') {
        this.preserveCurrentPickSelectionOnSequenceUpdate = true
        if (this.sequenceBoxSelection) {
          this.view.selectCollection(this.currentPickSelection)
        }
      }
      this.saveState()
    },

    updateSequenceSelection(sequenceId) {
      this.currentSequenceId = sequenceId
    },

    showGripperOverlay(points, placeX, placeY, placeRotation) {
      if (this.side === 'L') {
        this.view.showGripperBorder(points, placeX, placeY, placeRotation)
      }
    },

    setInitialPickSelection() {
      return (this.initialSequences && this.initialSequences.length > 0) ? [...this.initialSequences[0].pick[0].boxesGroup] : []
    },

    hasPickSelection(sequences, selection) {
      return selection.length > 0 && sequences.some(sequence =>
        sequence.pick && sequence.pick.some(pick =>
          pick.boxesGroup &&
          pick.boxesGroup.length === selection.length &&
          pick.boxesGroup.every((boxId, index) => boxId === selection[index])
        )
      )
    },

    populateStrategies() {
      this.availableStrategies = []
      if (this.patternGenResponse == null) {
        return
      }
      for (const strategy of this.patternGenResponse.plan.strategies) {
        this.availableStrategies.push({
          id: strategy.strategy_id,
          title: strategy.name
        })
      }
    },

    populateSymmetries() {
      this.availableSymmetries = []
      if (this.selectedStrategy == null) {
        return
      }
      const strategy = this.patternGenResponse.plan.strategies.find(s => s.strategy_id === this.selectedStrategy)
      for (const layer of strategy.layers.filter(l => l.type === 'B')){
        this.availableSymmetries.push({
          id: layer.symmetry,
          title: layer.symmetry
        })
      }
    },

    updateGeneratedBoxPositions() {
      console.debug('LPC.updateGeneratedBoxPositions: ', this.id, this.side, this.selectedStrategy, this.selectedSymmetry)
      if (this.id > 1 || this.side === 'R') {
        return
      }
      const symmetry = this.id === 0 ? 'none' : this.selectedSymmetry
      const layerName = this.id === 0 ? 'A' : 'B'
      this.selGeneratedBoxPositions = this.mapBoxesToBoxPositions(this.selectedStrategy, symmetry, layerName)
      this.drawLayer()
      this.editor.save()
      if (this.id === 0) {
        this.populateSymmetries()
        this.$emit('selectedStrategy', this.selectedStrategy)
      }
    },
    handleAction(val) {
      console.log('val', val)
      switch (val) {
        case 'center':
          this.center()
          break
        case 'clear':
          this.clear()
          break
        case 'delete':
          this.deleteBox()
          break
        case 'rotate':
          this.rotateBox()
          break
        case 'selectAll':
          this.selectAll()
          break
        case 'deselectAll':
          this.deselectAll()
        break
      }
    },
    getFilteredActions() {
      let actionsList = [
        {
          value: 'center',
          text: 'patternStep.center',
          icon: 'center_focus_strong',
          disabled: this.reorderManuallyMode || this.isAnySequence(),
          visible: this.mode === 'full'
        },
        {
          value: 'clear',
          text: 'patternStep.clear',
          icon: 'clear_all',
          disabled: this.reorderManuallyMode || this.isAnySequence(),
          visible: this.mode === 'full'
        },
        {
          value: 'rotate',
          text: 'patternStep.rotate',
          icon: 'rotate_right',
          disabled: this.deleteAndRotateBoxAreDisabled(),
          visible: this.mode === 'full'
        },
        {
          value: 'delete',
          text: 'patternStep.delete',
          icon: 'delete',
          disabled: this.deleteAndRotateBoxAreDisabled(),
          visible: this.mode === 'full'
        },
        {
          value: 'selectAll',
          text: 'patternStep.selectAll',
          icon: 'select_all',
          disabled: !this.autoOrder || this.boxPositions.length === 0 ||
              this.multiSelect || this.isAnySequence() || this.sequenceBoxSelection,
          visible: this.side === 'L' && !this.allSelected()
        },
        {
          value: 'deselectAll',
          text: 'patternStep.deselectAll',
          icon: 'deselect',
          disabled: false,
          visible: this.side === 'L' && this.allSelected() && !this.sequenceBoxSelection
        }
      ]
      return actionsList.filter(a => a.visible)
    },
    mapBoxesToBoxPositions(selectedStrategy, selectedSymmetry, layerName) {
      const boxes = this.patternGenResponse.plan.strategies.find(s => s.strategy_id === this.selectedStrategy).layers
          .find(l => l.type === layerName && l.symmetry === selectedSymmetry).boxes
      let generatedPositions = []
      for (const box of boxes) {
        const bp = {
          id: box.box_id,
          x: box.center_x,
          y: box.center_y,
          rotation: box.rotation_deg
        }
        generatedPositions.push(bp)
      }
      return generatedPositions
    },

    resetGeneratedPatternPlan() {
      this.selectedStrategy = null
      this.selectedSymmetry = null
      this.$emit('selectedStrategy', this.selectedStrategy)
    }
  }
}

</script>
<style>
.toolbar {
  background-color: #e0e0e0 !important;
  padding: 0 !important;
}

.checkbox {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
}

.pallet-container {
  /*height: 100%;*/
  display: flex;
  flex-direction: column;
}

.workspace {
  display: flex;
  align-items: stretch;
  flex: 1 1 auto;
  flex-direction: row;
  min-height: 0;
  overflow: hidden;
}

.workspace-height {
  height: 700px;
}

@media screen and (min-height: 400px), screen and (min-width: 900px) {
  .workspace-height {
    height: 400px;
  }
}

@media screen and (min-height: 700px), screen and (min-width: 1200px)  {
  .workspace-height {
    height: 500px;
  }
}

@media screen and (min-height: 900px), screen and (min-width: 1600px)  {
  .workspace-height {
    height: 700px;
  }
}

.asideTools {
  background-color: #e0e0e0;
  width: 200px;
  padding-left: 10px;
}

.asideToolsCustom {
  background-color: #e0e0e0;
  flex: 0 0 320px;
  padding: 0 10px;
  height: 100%;
  min-width: 0;
}

.asideToolsCustom .layout {
  flex-wrap: nowrap;
}

.paledit {
  background-color: #f2f2f2;
  position: relative;
  min-width: 0 !important;
  min-height: 0;
  overflow: hidden;
  padding: 0 10px;
  display: flex;
  flex: 2 1 auto;
}

.paledit canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.conveyor-preview-wrap {
  background-color: #f2f2f2;
  flex: 1 1 0;
  min-height: 0;
  padding: 4px 0 8px;
}

.conveyor-preview {
  background-color: #f7f8f6;
  border: 1px solid #c5cac6;
  border-radius: 6px;
  box-shadow: inset 0 1px 0 #ffffff;
  height: 100%;
  min-height: 320px;
  overflow: hidden;
  width: 100%;
}

.conveyor-preview-svg {
  display: block;
  height: 100%;
  pointer-events: none;
  width: 100%;
}

.conveyor-preview-belt {
  fill: #d9d9d0;
  stroke: #b7b7ae;
  stroke-width: 2;
}

.conveyor-preview-rail {
  fill: #b0bbbb;
  stroke: #8d9999;
  stroke-width: 2;
}

.conveyor-preview-flow {
  opacity: 0.55;
  stroke: #5f6a6a;
  stroke-dasharray: 18 16;
  stroke-linecap: round;
  stroke-width: 7;
}

.conveyor-preview-flow-mark {
  fill: none;
  opacity: 0.28;
  stroke: #5f6a6a;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 8;
}

.conveyor-preview-reference {
  stroke: #5b6770;
  stroke-dasharray: 8 6;
  stroke-opacity: 0.55;
  stroke-width: 2;
}

.conveyor-preview-axis line {
  stroke-width: 3;
}

.conveyor-preview-axis text {
  font-size: 24px;
  font-weight: 600;
}

.conveyor-preview-origin {
  fill: #ffffff;
  stroke: #5b6770;
  stroke-width: 3;
}

.conveyor-preview-axis-x {
  stroke: #C62828;
}

.conveyor-preview-axis-y {
  stroke: #2E7D32;
}

.conveyor-preview-axis-label-x {
  fill: #C62828;
}

.conveyor-preview-axis-label-y {
  fill: #2E7D32;
}

.conveyor-preview-box-face {
  fill: #cfa86f;
  stroke: #8b6f49;
  stroke-width: 1;
}

.conveyor-preview-box-outline {
  fill: none;
  stroke: #6f6256;
  stroke-width: 2;
}

.conveyor-preview-pick-current .conveyor-preview-box-outline {
  stroke: #C62828;
  stroke-width: 4;
}

.conveyor-preview-label {
  stroke: rgba(117, 102, 83, 0.35);
  stroke-width: 1;
  opacity: 0.75;
}

.conveyor-preview-gripper {
  fill: #1E88E5;
  fill-opacity: 0.1;
  stroke: #1E88E5;
  stroke-width: 3;
  stroke-dasharray: 10 8;
}

.conveyor-preview-pick-current .conveyor-preview-gripper {
  fill: #C62828;
  fill-opacity: 0.08;
  stroke: #C62828;
}

.conveyor-preview-gripper-axis-x,
.conveyor-preview-gripper-axis-y {
  stroke-linecap: round;
  stroke-width: 5;
}

.conveyor-preview-gripper-axis-x {
  stroke: #C62828;
}

.conveyor-preview-gripper-axis-y {
  stroke: #2E7D32;
}

.conveyor-preview-gripper-axis-label {
  font-size: 22px;
  font-weight: 600;
}

.conveyor-preview-gripper-axis-label-x {
  fill: #C62828;
}

.conveyor-preview-gripper-axis-label-y {
  fill: #2E7D32;
}

.i-right {
  padding-left: 0 !important;
  margin-left: 0.3em !important;
}

.custom-height-select .v-input__control {
  height: 40px !important;
  min-height: 40px !important;
}

.custom-height-select input {
  height: 40px !important;
  line-height: 40px !important;
}

.workspace-bottom {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  background-color: #f2f2f2;
}

.btn-rotate-pv {
  min-width: 0 !important;
  margin-right: 0.1em !important;
  margin-left: 0.1em !important;
}
</style>
